var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.cssUserAvatar),attrs:{"src":`${_vm.$config.savatarUrl}/${_vm.username}?s=${_vm.savatarSize}`,"alt":"Avatar image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }